<div class="flex flex-col justify-start gap-y-2" *transloco="let t">
  <app-setting-row>
    <ng-container label>{{ t("day-parting-inputs.enable_day_parting") }}</ng-container>

    <IToggle
      [disabled]="disabled"
      [checked]="!!enabledDayParting()"
      (checkedChange)="switchDisableDayParting(!enabledDayParting())"
    />
  </app-setting-row>
  @if (enabledDayParting()) {
    <div class="w-0 min-w-full">
      <div class="mt-1 flex content-start items-center">
        <div>
          <span [class]="textSize">{{ t("day-parting-inputs.disable_strategy_from") }} </span>
          <span class="inline-flex">
            <ISelectMenu
              [value]="daypartingPauseHour()"
              (valueChange)="selectDayPartingPauseHour($event)"
              [popoverWidth]="90"
              [disabled]="disabled"
            >
              <ISelectTrigger>
                <ISelectValue>
                  <div *iSelectValue="let hour">{{ hour }}:00</div>
                </ISelectValue>
              </ISelectTrigger>
              <ISelectContent>
                @for (hour of HOURS; track hour) {
                  <ISelectOption [value]="hour">{{ hour }}:00</ISelectOption>
                }
              </ISelectContent>
            </ISelectMenu>
          </span>
          <span [class]="textSize"> {{ t("day-parting-inputs.to_hours") }} </span>
          <span class="inline-flex">
            <ISelectMenu
              [value]="daypartingReactivationHour()"
              (valueChange)="selectDayPartingReactivationHour($event)"
              [popoverWidth]="90"
              [disabled]="disabled"
            >
              <ISelectTrigger>
                <ISelectValue>
                  <div *iSelectValue="let hour">{{ hour }}:00</div>
                </ISelectValue>
              </ISelectTrigger>
              <ISelectContent>
                @for (hour of HOURS; track hour) {
                  <ISelectOption [value]="hour">{{ hour }}:00</ISelectOption>
                }
              </ISelectContent>
            </ISelectMenu>
          </span>
          @if (selectedTimeZone()) {
            <div class="mt-1 text-xs text-gray-700">
              {{ t("hourly-chart.hours_displayed", [formattedTimeZone(), timeZoneOffest()]) }}
            </div>
          }
          @if (daypartingPauseHour() === daypartingReactivationHour()) {
            <div class="text-danger">{{ t("day-parting-inputs.start_and_end_hour_must_be_different") }}</div>
          }
        </div>
      </div>
      <div class="text-danger mt-2 flex items-center justify-start rounded-sm border bg-gray-50">
        @let s = savings();
        <ul class="m-0 flex list-none flex-col gap-1 p-2 text-sm font-medium text-gray-800">
          <li>
            {{ t("day-parting-inputs.missed_ad_sales") }}
            {{ s?.totalAdSalesOnPeriod | currency: currencyCode() : "symbol" : "1.2-2" : locale }}
            @if (s?.totalAdSalesOnPeriod && s?.totalAdSales) {
              <span>({{ s!.totalAdSalesOnPeriod / s!.totalAdSales | percent: "1.2-2" }})</span>
            }
          </li>
          <li>
            {{ t("day-parting-inputs.saved_spend") }}
            {{ s?.totalCostOnPeriod | currency: currencyCode() : "symbol" : "1.2-2" : locale }}
            @if (s?.totalCostOnPeriod && s?.totalCost) {
              <span>({{ s!.totalCostOnPeriod / s!.totalCost | percent: "1.2-2" }})</span>
            }
          </li>
          @if (s?.totalCostOnPeriod && s?.totalAdSalesOnPeriod) {
            <li>
              {{ t("day-parting-inputs.acos_on_the_paused_period") }}
              {{ s!.totalCostOnPeriod / s!.totalAdSalesOnPeriod | percent: "1.2-2" }}
            </li>
          }
          @if (strategy().acosTarget) {
            <li>{{ t("day-parting-inputs.target_acos") }} {{ strategy().acosTarget | percent: "1.2-2" }}</li>
          }
        </ul>
      </div>
    </div>
  }
</div>
